import { PlatformLocation } from '@angular/common';
import { Component, Inject, Optional } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { CustomerModalBaseComponent } from '../../../customer/shared/customer-modal-base.component';
import { MvdModalService } from '../../../shared/services/modal/mvd-modal.service';

export class HistoricalCertificatesContext {
    constructor(public customerNumberId: number, public topOfStackId: number) { }
}

@Component({
    selector: 'historical-customer-mrp-certificates-modal',
    templateUrl: './historical-customer-mrp-certificates-modal.html',
})

export class HistoricalCustomerMrpCertificatesModal extends CustomerModalBaseComponent {
    public customerNumberId: number;

    constructor(
        public location: PlatformLocation,
        public dialogRef: MatDialogRef<HistoricalCustomerMrpCertificatesModal>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: HistoricalCertificatesContext,
        public modalService: MvdModalService
    ) {
        super(modalService);
        this.customerNumberId = this.data.customerNumberId;
    }

    public ngOnInit(): void { }

    public cancel(): void {
        this.dialogRef.close();
    }
}
